import { MeetingState } from '../../../types';
import CallActions from './CallActions';
import UpNext, { NextProspectDetails } from './UpNext';

interface DialerEndActionsProps {
  isMuted: boolean;
  meetingState: MeetingState;
  callNextProspect: () => void;
  exitCall: () => void;
  stopCall: () => void;
  toggleMute: () => void;
  nextProspectDetails?: NextProspectDetails;
}

const DialerEndActions = ({
  isMuted,
  meetingState,
  callNextProspect,
  exitCall,
  stopCall,
  toggleMute,
  nextProspectDetails,
}: DialerEndActionsProps) => {
  const showUpNext = meetingState === MeetingState.IDLE;
  return showUpNext ? (
    <UpNext nextProspectDetails={nextProspectDetails} exitCall={exitCall} callNextProspect={callNextProspect} />
  ) : (
    <CallActions endCall={stopCall} meetingState={meetingState} isMuted={isMuted} toggleMute={toggleMute} />
  );
};

export default DialerEndActions;
